import React from "react";
import { Link } from "react-router-dom";
import { Carousel } from "3d-react-carousal";

import rx from "../../../../../../assets/imgs/carousel_slider/bull96.webp";
import trax1 from "../../../../../../assets/imgs/carousel_slider/rb950.webp";
import trax2 from "../../../../../../assets/imgs/carousel_slider/bull96.webp";
import trax3 from "../../../../../../assets/imgs/carousel_slider/ajax10005.webp";

import "./Hero.css";

const Hero = () => {
  let slides = [
    <img src={trax1} alt="" className="carousel_image" />,
    <img src={trax2} alt="" className="carousel_image carousel_image_trax2" />,
    <img src={trax3} alt="" className="carousel_image  " />,
  ];

  return (
    <section className="static-hero hero_section" style={{ height: "100vh" }}>
      <div className="hero-container">
        <div className="hero-inner">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-7 col-12">
                <div className="wpo-static-hero-inner">
                  <div
                    data-swiper-parallax="200"
                    className="slide-visible-text"
                  >
                    <h2>SEMAT</h2>
                  </div>
                  <div data-swiper-parallax="300" className="slide-title">
                    <h2>
                      SOCIÉTÉ D'EQUIPEMENTS ET DE{" "}
                      <span style={{ color: "#CAAB06" }}>MATÉRIELS</span>
                    </h2>

                    <h3 className="h3_title_BTP">
                      Concessionnaire de materiels industriels et BTP
                    </h3>
                  </div>
                  <div className="row btn-slide-wrapper">
                  <div data-swiper-parallax="400" className="slide-btn slide-btn-first">
                    <Link className="theme-btn" to="/others/btp">
                      BTP
                    </Link>
                  </div>
                  <div data-swiper-parallax="400" className="slide-btn slide-btn-second">
                    <Link className="theme-btn" to="/others/nettoyage">
                      Nétoyage
                    </Link>
                  </div>
                  </div> 
                  <div className="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid hero_container_2">
            <div className=" image_container_hero row align-items-center">
              {/* <div className="col-xl-6 col-lg-7 col-12"> */}
              <img src={rx} alt="zrf" className="home_page_trax" />
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="static-hero-right">
        <div className="static-hero-img">
          <div className="static-hero-img-inner">
            {/* <img src={rx} alt="zrf" /> */}

            <Carousel
              slides={slides}
              autoplay={true}
              arrows={false}
              interval={5000}
              style={{
                height: "200px",
                width: "500px",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
